module.exports = __webpack_public_path__ + "static/media/search.45bc587c.svg";